import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex h-full ml-6" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.params.value)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "h-8 min-w-8 my-auto",
          src: _ctx.params.value
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true)
  ]))
}